import React from 'react';
import { ChevronLeft } from '@saleshandy/icons';
import history from '../../../../../../shared/history';
import { accessibleOnClick } from '../../../../../../shared/utils/accessible-on-click';
import { Routes } from '../../../../../../shared/routes';

const UpgradePlanHeader = () => {
  const location = history?.location;
  const goBack = () => {
    const emailOutreach = location?.pathname?.includes(
      Routes.Setting_Billing_Upgrade_Email_Outreach_Plan,
    );
    const inboxPlacementRadar = location?.pathname?.includes(
      Routes.Setting_Billing_Inbox_Placement_Radar,
    );
    const dialer = location?.pathname?.includes(
      Routes.Setting_Billing_Upgrade_Dialer_Plan,
    );

    let pathname = '/billing/subscriptions/lead-finder';
    if (emailOutreach) {
      pathname = '/billing/subscriptions/email-outreach';
    } else if (inboxPlacementRadar) {
      pathname = '/billing/subscriptions/inbox-placement-radar';
    } else if (dialer) {
      pathname = '/billing/subscriptions/dialer';
    }

    history.push({ pathname });
  };

  return (
    <div className="upgrade-plan-header" {...accessibleOnClick(goBack)}>
      <ChevronLeft />
      <span>Back</span>
    </div>
  );
};

export default UpgradePlanHeader;
